export default __webpack_public_path__ + "static/media/energy-saving.d3d15f57.png";